import { useMemo, useState } from "react";
import { Down } from "../../../assets/svgIcon/listView/Down";
import { ReactComponent as UpIcon } from "../../../assets/svgIcon/listView/UpBlue.svg";
import { PopupModal } from "../../../components/TopBar/PopupModal/PopupModal";
import {
  getHideEmptyLanesAriaLabel,
  getHideEmptyLanesButtonPill,
  getHideEmptyLanesMenuOptions,
  isHideEmptyLanesActive,
  resolveHideEmptyLanesMenuSelection,
} from "../../../../shipment/constants/shipmentCombinedBoard.js";

const HIDE_EMPTY_LANES_MENU_HINT =
  "Lanes with no shipments are left off this board.";

/**
 * Shipment board control for hiding empty status and/or milestone lanes.
 */
export function HideEmptyLanesMenu({ mode, onChange, selectedCurrentView }) {
  const [isOpen, setIsOpen] = useState(false);
  const subType = selectedCurrentView?.sub_type;

  const options = useMemo(() => getHideEmptyLanesMenuOptions(subType), [subType]);
  const selectedValue = useMemo(
    () => resolveHideEmptyLanesMenuSelection(mode, subType),
    [mode, subType],
  );
  const isActive = isHideEmptyLanesActive(mode);
  const pill = useMemo(
    () => getHideEmptyLanesButtonPill(mode, subType),
    [mode, subType],
  );
  const ariaLabel = useMemo(
    () => getHideEmptyLanesAriaLabel(mode, subType),
    [mode, subType],
  );

  const closeMenu = () => setIsOpen(false);

  const handleSelect = value => {
    onChange(value);
    closeMenu();
  };

  const handleClear = event => {
    event.stopPropagation();
    onChange("none");
    closeMenu();
  };

  const toggleMenu = () => setIsOpen(open => !open);

  return (
    <div className="selectBox hideEmptyLanesMenu">
      <div
        className={`milestoneBtn hideEmptyLanesTrigger${
          isActive ? " hideEmptyLanesTriggerActive" : ""
        }${isOpen ? " hideEmptyLanesTriggerOpen" : ""}`}
      >
        <button
          type="button"
          className="hideEmptyLanesTriggerMain"
          onClick={toggleMenu}
          aria-expanded={isOpen}
          aria-pressed={isActive}
          aria-label={ariaLabel}
        >
          <span className="hideEmptyLanesTriggerLabel">Hide</span>
          {isActive && pill && (
            <>
              <span className="hideEmptyLanesActiveDot" aria-hidden="true" />
              <span className="hideEmptyLanesModePill">{pill}</span>
            </>
          )}
          {isOpen ? <UpIcon /> : <Down />}
        </button>
        {isActive && (
          <button
            type="button"
            className="hideEmptyLanesClear"
            aria-label="Show all lanes"
            onClick={handleClear}
          >
            ×
          </button>
        )}
      </div>
      {isOpen && (
        <PopupModal
          styleOfModal={{
            position: "absolute",
            top: "calc(100% + 4px)",
            right: 0,
            zIndex: 20,
          }}
          closeModal={closeMenu}
        >
          <div className="optionsOfSelect hideEmptyLanesOptions" role="menu">
            {options.map(option => {
              const isSelected = selectedValue === option.value;
              return (
                <div
                  key={option.value}
                  className={`optionItem hideEmptyLanesOption${
                    isSelected ? " activeItem" : ""
                  }`}
                  role="menuitemradio"
                  aria-checked={isSelected}
                  onClick={() => handleSelect(option.value)}
                >
                  <div
                    className={`hideEmptyLanesRadio${
                      isSelected ? " hideEmptyLanesRadioSelected" : ""
                    }`}
                    aria-hidden="true"
                  />
                  <div className="hideEmptyLanesOptionLabel">{option.label}</div>
                </div>
              );
            })}
            <p className="hideEmptyLanesMenuHint">{HIDE_EMPTY_LANES_MENU_HINT}</p>
          </div>
        </PopupModal>
      )}
    </div>
  );
}
